const FETCH_PRODUCT_CARE_REQUEST = 'FETCH_PRODUCT_CARE_REQUEST'
const FETCH_PRODUCT_CARE_SUCCESS = 'FETCH_PRODUCT_CARE_SUCCESS'
const FETCH_PRODUCT_CARE_FAILURE = 'FETCH_PRODUCT_CARE_FAILURE'

export { FETCH_PRODUCT_CARE_REQUEST, FETCH_PRODUCT_CARE_SUCCESS, FETCH_PRODUCT_CARE_FAILURE }
